module.exports = require("core-js-pure/stable/instance/filter");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/filter.js
// module id = 244
// module chunks = 0 1